import { Link } from "react-router-dom";
import { isAgentPortal } from "js/utilities";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation, Trans } from "react-i18next";

const TermsOfUse = () => {
  const { t } = useTranslation();
  useBreadcrumb([
    {
      name: "Home",
      url: `${isAgentPortal() ? "/dashboard" : "/policies"}`,
    },
    { name: "Terms of Use", url: "#" },
  ]);
  return (
    <>
      <div className="container ui-component-spacing">
        <h1>{t("TermsOfUse-title")}</h1>
        <hr />
      </div>

      <div className="container ui-component-spacing font-body">
        <p className="mb-6">{t("TermsOfUse-date-1")}</p>
        <p>{t("TermsOfUse-point-1")}</p>

        <br />

        <p>{t("TermsOfUse-point-2")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-1")}</h2>
        <p>{t("TermsOfUse-point-3")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-2")}</h2>
        <p>
          <Trans
            i18nKey="TermsOfUse-point-4"
            components={{
              link1: <Link to="/privacy-policy"></Link>,
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("TermsOfUse-subTitle-3")}</h2>
        <p>{t("TermsOfUse-point-5")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-4")}</h2>
        <p>{t("TermsOfUse-point-6")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-5")}</h2>
        <p>{t("TermsOfUse-point-7")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-6")}</h2>
        <p>{t("TermsOfUse-point-8")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-7")}</h2>
        <p>{t("TermsOfUse-point-9")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-8")}</h2>
        <p>{t("TermsOfUse-point-10")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-9")}</h2>
        <p>{t("TermsOfUse-point-11")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-10")}</h2>
        <p>{t("TermsOfUse-point-12")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-11")}</h2>
        <p>{t("TermsOfUse-point-13")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-12")}</h2>
        <p>{t("TermsOfUse-point-14")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-13")}</h2>
        <p>{t("TermsOfUse-point-15")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-14")}</h2>
        <p>{t("TermsOfUse-point-16")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-15")}</h2>
        <p>{t("TermsOfUse-point-17")}</p>

        <br />

        <h2>{t("TermsOfUse-subTitle-16")}</h2>
        <p>{t("TermsOfUse-point-18")}</p>
      </div>
    </>
  );
};

export default TermsOfUse;
